import { useGetCheckinSettingsQuery } from '../../../api/cdnApi'
import { createLogger } from '../../../app/logger'
import { CheckinEvent, CheckinSettingsLoading } from '../../../app/types'
import { useEventId } from '../../../app/location'

// eslint-disable-next-line no-unused-vars
const logger = createLogger({
  prefix: 'checkin-settings::useCheckinSettings',
})

export default function useCheckinSettings(): CheckinSettingsLoading {
  const eventId = useEventId()

  const { data: settingsFromApi, isLoading: isLoadingCheckinSettings } =
    useGetCheckinSettingsQuery(eventId, {
      skip: !eventId,
      pollingInterval: 30_000,
      refetchOnMountOrArgChange: true,
    })

  const checkinAllSettings = settingsFromApi ?? {
    event: {
      eventId,
    } as CheckinEvent,
  }

  return {
    checkinAllSettings,
    isLoadingCheckinSettings,
  }
}
